module.exports = __webpack_public_path__ + "img/sky.da0e2eb0.jpg";